import { Table } from 'components';
import {
    fetchStatusBulkAccountVerificationRequest,
    downloadBulkAccountVerificationFileRequest
} from './redux/BulkAccountVerification.actions';
import React, { useMemo, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

const TableHead = props => {
    return (
        <div className="mail-head clearfix">
            <div className="headTitle">
                <p>Recent Uploaded</p>
            </div>
        </div>
    );
};

const BulkAccountVerificationTable = ({ actions, bulkAccountVerificationData, pageSize, setPageSize }) => {
    const pageSizeOptions = [10, 20, 40, 60];
    const [pageCount, setPageCount] = useState(0);
    

    const { pagination, tableData, error } = bulkAccountVerificationData;

    const columnsRecent = useMemo(
        () => [
            { header: 'Request ID', accessor: 'requestId' },
            { header: 'Merchant ID', accessor: 'merchantId' },
            { header: 'Start Time' , accessor: 'startTime'},
            { header: 'End Time', accessor: 'endTime'},
            { header: 'Status', accessor: 'status' },
            { header: 'Valid Count', accessor: 'validCount' },
            { header: 'Invalid Count', accessor: 'invalidCount' },
            { header: 'Remark', accessor: 'remark' },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const fetchData = useCallback(
        ({ pageSize, pageIndex }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,

            const data = {
                pageSize,
                pageNo: pageIndex,
            };
            actions.fetchStatusBulkAccountVerificationRequest({
                ...data,
            });
            setPageSize(pageSize);
        },
        [actions]
    );

    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [pageSize, pagination.totalNumberOfRecords]);

    return (
        <>
            <Table
                columns={columnsRecent}
                data={tableData}
                tableHead={<TableHead />}
                fetchData={fetchData}
                tableFilters={null}
                loading={false}
                userActions={data => (
                    <ManageBulkRefundActions
                        data={data}
                        downloadRequest={payload => {
                            actions.downloadBulkAccountVerificationFileRequest(payload);
                        }}
                    />
                )}
                error={error && error.errorMessage}
                isPaginationEnable
                pageCount={pageCount}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
            />
        </>
    );
};

const ManageBulkRefundActions = ({ data, downloadRequest }) => {
    const handleDownload = () => {
        const payload = {};
        payload.requestId = data.original.requestId;
        payload.fileTypeEnum =
            data.original.status === 'COMPLETED' ? 'PROCESSED' : 'UPLOADED';
        downloadRequest(payload);
    };

    const isDisabled = data.original.status === 'INITIATED';

    return (
        <div
            className={`userAction  multiItem ${isDisabled ? 'disabled' : ''}`}
        >
            <button
                className="download"
                disabled={isDisabled}
                title={
                    isDisabled
                        ? 'No Download Available for this file'
                        : 'Download file'
                }
                onClick={handleDownload}
            />
        </div>
    );
};

ManageBulkRefundActions.propTypes = {
    data: PropTypes.object,
    downloadRequest: PropTypes.func,
};

BulkAccountVerificationTable.propTypes = {
    actions: PropTypes.object,
    bulkAccountVerificationData: PropTypes.object,
    pageSize: PropTypes.number,
    setPageSize: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchStatusBulkAccountVerificationRequest,
            downloadBulkAccountVerificationFileRequest
        },
        dispatch
    ),
});

const mapStateToProps = ({ auth, bulkAccountVerificationData, loader }) => ({
    auth,
    bulkAccountVerificationData,
    loader,
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(BulkAccountVerificationTable);
